import { Component, Input } from '@angular/core';

@Component({
    selector: 'sc-yesno-display',
    templateUrl: './sc-yesno-display.component.html',
})
export class ScYesNoDisplayComponent {
    @Input() label: string;
    @Input() isPositive: boolean;
    @Input() showIcon: boolean;
    @Input() iconColour: string;
    @Input() useBoldFont: boolean;

    constructor() {
        this.label = 'Yes';
        this.isPositive = true;
        this.showIcon = true;
        this.useBoldFont = false;
        this.iconColour = '';
    }
}
